/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
//import logo from '../assets/images/logoFS.png';
import fondoFS from '../assets/images/logo_FS_TALENTO_2.png';
import '../styles/home.css';
import msgNotificacion from '../scripts/notification';
import msgAlerta from '../scripts/alert';

// Material MUI
import {
  Button,
  Tooltip,
  Grid,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';

// Material Icons
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';

// Components
import Heading from '../components/heading/Heading';
import CustomAlerts from '../components/alert/CustomAlerts';
import { isMobile, isDesktop } from 'react-device-detect';

// Redux
import { useDispatch } from 'react-redux';
import { showProgress } from '../redux/reducers/progress.Slice';
import { NAME_PROJECT, ROLES_REG_UBICACION } from '../redux/constants';

// Services
import HomeService from '../services/homeService';

export default function Home() {
  const dispatch = useDispatch()
  const [latitude, setLatitude] = useState(null)
  const [longitude, setLongitude] = useState(null)
  const [message, setMessage] = useState(null)
  const [title, setTitle] = useState(null)
  const [openMessage, setOpenMensaje] = useState(false)
  const [severity, setSeverity] = useState('error')
  const [hiddenLocation, setHiddenLocation] = useState(true)
  const [openTipoDialog, setOpenTipoDialog] = useState(false)
  const userLogin = JSON.parse(localStorage.getItem('user'))

  const geoOptions = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  }

  const getLocation = () => {
    try {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(successCallback, errorCallback, geoOptions)
        setOpenMensaje(false)
      } else {
        setOpenMensaje(true)
        setMessage('La geolocalización no es compatible con este navegador.')
        setTitle('Error al obtener la localización.')
      }
    } catch (error) {
      console.error(error)
    }
  }

  const successCallback = (position) => {
    try {
      dispatch(showProgress(true))

      setTimeout(() => {
        setLatitude(position.coords.latitude)
        setLongitude(position.coords.longitude)

        dispatch(showProgress(false))        
        setMessage('Ubicación obtenida correctamente.')
        setTitle(null)
        setSeverity('success')
      }, 1000)

    } catch (error) {
      console.error(error)
    }
  }

  const errorCallback = (error) => {
    try {
      dispatch(showProgress(false))
      setOpenMensaje(true)
      setTitle('Error al obtener la localización.')
      setMessage(error.message)
    } catch (error) {
      console.error(error)
    }
  }

  const saveLocationWithTipo = async (tipoMarcacion, lat, lon) => {
    try {
      if (lat == null || lon == null) {
        setOpenMensaje(true)
        setMessage('No se pudo obtener la ubicación para registrar la marcación.')
        setTitle('Error al registrar ubicación.')
        return
      }

      const data = {
        codEmpleado: userLogin.CodigoEmpleado,
        codEmpresa: 'FSRA',
        latitud: lat.toString(),
        longitud: lon.toString(),
        dispositivo: isMobile ? 'Móvil' : isDesktop ? 'Computadora' : 'Tablet',
        tipoMarcacion
      }

      dispatch(showProgress(true))

      HomeService.saveLocationEmployee(data)
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            dispatch(showProgress(false))
            return
          }

          setTimeout(() => {
            if (response.Codigo === 1) {
              setHiddenLocation(true)
              setOpenMensaje(false)
              setLongitude(null)
              setLatitude(null)

              msgAlerta('Exito!', `${response.Mensaje} (${tipoMarcacion})`, 'success')
            } else {
              setOpenMensaje(true)
              setMessage(response.Mensaje)
              setTitle('Error al registrar ubicación.')
            }

            dispatch(showProgress(false))
          }, 1000)
        })
        .catch((error) => {
          console.error(error)
          dispatch(showProgress(false))
        })
    } catch (error) {
      console.error(error)
      dispatch(showProgress(false))
    }
  }

  const handleSelectTipoMarcacion = (tipoMarcacion) => {
    setOpenTipoDialog(false)

    if (latitude != null && longitude != null) {
      saveLocationWithTipo(tipoMarcacion, latitude, longitude)
      return
    }

    if (!navigator.geolocation) {
      setOpenMensaje(true)
      setMessage('La geolocalización no es compatible con este navegador.')
      setTitle('Error al obtener la localización.')
      return
    }

    dispatch(showProgress(true))
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude
        const lon = position.coords.longitude
        setLatitude(lat)
        setLongitude(lon)
        saveLocationWithTipo(tipoMarcacion, lat, lon)
      },
      errorCallback,
      geoOptions
    )
  }

  const accessData = () => {
    try {
      
      if (ROLES_REG_UBICACION.includes(userLogin.CodigoRol)) {
        setHiddenLocation(false)
      } else {        
        setHiddenLocation(true)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const getComprobante = async () => {
    try {
      dispatch(showProgress(true))
      const urlPath = process.env.REACT_APP_API_URL;
      //const urlPath = 'http://192.168.5.48:81';
      const comprobanteEmp = `Comprobante_${userLogin.CodigoEmpleado}`;
      const fileUrl = `${urlPath}/RRHH/Comprobantes/${comprobanteEmp}.pdf`;

      const response = await fetch(fileUrl);
      console.log(response)

      if (response.status !== 200) {
        msgAlerta('Error al obtener comprobante de Pago', 'Su comprobante no fue encontrado en el directorio', 'warning')
        dispatch(showProgress(false))
        return
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.style.display = 'none';
      a.href = url;
      a.download = `${comprobanteEmp}.pdf`;

      document.body.appendChild(a);

      a.click();
      window.URL.revokeObjectURL(url);

      setTimeout(() => {
        dispatch(showProgress(false))
      }, 500)
    } catch (error) {
      dispatch(showProgress(false))
      console.error(error)
    }
  }

  useEffect(() => {
    document.title = `Home - ${NAME_PROJECT}`
    const access = localStorage.getItem('noAutorizado')

    if (access) {
      msgNotificacion('No tiene autorizado el acceso a esta URL. Contacte al administrador del Sitio', 'warning')
      localStorage.removeItem('noAutorizado')
    }

    dispatch(showProgress(true))

    setTimeout(() => {
      accessData()
      dispatch(showProgress(false))
    }, 500)
  }, [])

  return <div className='App-content'>
    <Heading className='mt-0 py-0 w-100 heading justify-content-center text-transform-none'>
      <div className='heading-text flex-column w-100'>
        <i className='bx bxs-home'></i>
        <span>Página de Inicio</span>

        <Stack>
          <Tooltip title='Descagar comprobante de Pago'>
            <Button
              variant='contained'
              className='text-transform-none me-2 btn-refresh-marc'
              color='info'
              startIcon={<FileDownloadIcon />}
              onClick={() => getComprobante()}
              size='small'
              hidden={true}
            >
              Descargar comprobante
            </Button>
          </Tooltip>
        </Stack>

      </div>
    </Heading>

    <Grid container backgroundColor='#f0f0f0'>
      <Stack width='100%' marginY={1} marginX={1} hidden={hiddenLocation}>
        <Stack direction='row' width='100%' spacing={1} className=''>
          <Tooltip title='Obtener ubicación'>
            <Button
              variant='contained'
              className='text-transform-none w-100 button-home'
              color='info'
              startIcon={<LocationSearchingIcon />}
              onClick={() => getLocation()}
              size='small'
            >
              Obtener ubicación
            </Button>
          </Tooltip>
          <Tooltip title='Registrar ubicación'>
            <Button
              variant='contained'
              className='text-transform-none w-100 button-home'
              color='success'
              startIcon={<MoreTimeIcon />}
              onClick={() => setOpenTipoDialog(true)}
              size='small'
            >
              Registrar marcación
            </Button>
          </Tooltip>

        </Stack>
      </Stack>

      <span className='text-center text-default w-100'>
        {latitude && longitude && (
          <span className='text-center'>
            Latitud: <strong className='text-success'>{latitude.toFixed(10)}</strong>
            <br />
            Longitud: <strong className='text-success'>{longitude.toFixed(10)}</strong>
          </span>
        )}
      </span>
       
      <CustomAlerts
        severity={severity}
        message={message || ''}
        title={title}
        open={openMessage}
        setOpen={setOpenMensaje}
      />

      <Dialog
        open={openTipoDialog}
        onClose={() => setOpenTipoDialog(false)}
        maxWidth='xs'
        fullWidth
      >
        <DialogTitle>Tipo de marcación</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Seleccione si esta marcación es de entrada o de salida.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ flexDirection: 'column', gap: 1, px: 3, pb: 2 }}>
          <Button
            variant='contained'
            color='success'
            fullWidth
            startIcon={<LoginIcon />}
            className='text-transform-none'
            onClick={() => handleSelectTipoMarcacion('ENTRADA')}
          >
            ENTRADA
          </Button>
          <Button
            variant='contained'
            color='warning'
            fullWidth
            startIcon={<LogoutIcon />}
            className='text-transform-none'
            onClick={() => handleSelectTipoMarcacion('SALIDA')}
          >
            SALIDA
          </Button>
          <Button
            variant='text'
            fullWidth
            className='text-transform-none'
            onClick={() => setOpenTipoDialog(false)}
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>

    </Grid>

    <div className='dv-home'>
      <img src={fondoFS} alt='logo FS' className='img-home' />
    </div>
  </div>
}